/**
 * Small shared helpers for the two sibling quantity-weighted attribute logs
 * (assets/wonderful-experience-source-log.js's `_experience_source_log` and
 * assets/wonderful-section-source-log.js's `_section_source_log`) — same
 * architecture, independent attributes, purely additive; this file only
 * extracts the parts that were byte-for-byte identical between them
 * (cart-URL resolution, the /cart.js GET itself, and live-quantity tallying)
 * so a fix to any of those only has to be made once. The parts that
 * genuinely differ per log (parsing/reconciling/persisting its own attribute
 * key, its own tally shape) stay in each module.
 *
 * Should load before both of the above — they fall back to a local, self-contained implementation
 * of these same helpers if this script didn't load in time (losing only the fetch-dedupe below, not
 * breaking outright), so load order here is a nice-to-have rather than a hard requirement.
 */
;(function () {
  function resolveCartUrl(path) {
    var root =
      typeof Shopify !== 'undefined' && Shopify.routes && Shopify.routes.root
        ? String(Shopify.routes.root).replace(/\/?$/, '/')
        : '/'
    return root + path
  }

  /**
   * Fetches /cart.js, collapsing concurrent callers into a single request:
   * if a fetch is already in flight when this is called again (e.g. both
   * sibling logs' hydrate()/computeCheckoutAttributes() firing around the
   * same tick, as checkout-experience.js's Promise.all does), every caller
   * shares that same in-flight promise instead of each firing its own GET.
   * The in-flight promise is cleared as soon as it settles, so this is a
   * request-collapsing dedupe, not a cache with a TTL — a caller that asks
   * after the in-flight request has already finished always gets a fresh one.
   */
  var inFlight = null
  function fetchCart() {
    if (inFlight) return inFlight
    inFlight = fetch(resolveCartUrl('cart.js'), {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
    })
      .then(function (res) {
        if (!res.ok) throw new Error('GET /cart.js failed: ' + res.status)
        return res.json()
      })
      .finally(function () {
        inFlight = null
      })
    return inFlight
  }

  function liveQuantitiesFromCart(cart) {
    var map = {}
    ;(cart.items || []).forEach(function (line) {
      var vid = String(line.variant_id)
      map[vid] = (map[vid] || 0) + (line.quantity || 0)
    })
    return map
  }

  window.WonderfulCartLogShared = {
    resolveCartUrl: resolveCartUrl,
    fetchCart: fetchCart,
    liveQuantitiesFromCart: liveQuantitiesFromCart,
  }
})()
